import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import { WhatisClientProvider } from './components/providers/ClientProvider';
import AuthProvider from './components/providers/AuthProvider';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import { ApolloProvider } from '@apollo/client';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
import { ErrorFallback } from 'ui/src/components/errors/ErrorFallback';
import 'react-tippy/dist/tippy.css';
import { AnnouncementProvider } from './components/dashboard/Context';
import { createClient } from './gql/ApolloClient';
import 'flowbite';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

declare global {
  interface Window {
    analytics: any;
  }
}

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.VITE_ENVIRONMENT,
  tracesSampleRate: 1,
});

const uri = `${process.env.VITE_API_BASE_URL}/graphql`;
const client = createClient(uri);

const appElement = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <WhatisClientProvider>
            <>
              <AnnouncementProvider>
                <AuthProvider client={client}>
                  <App />
                </AuthProvider>
              </AnnouncementProvider>

              <ToastContainer theme={'light'} hideProgressBar />
            </>
          </WhatisClientProvider>
        </BrowserRouter>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');
if (rootElement?.hasChildNodes()) {
  hydrate(appElement, rootElement);
} else {
  render(appElement, rootElement);
}
